var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';
import { useCollection, useEvent, useEvents, useGeoObjectCoords, useGeoObjectOptions, useGeoObjectProperties } from '../../hooks';
var createLayout = function (onCreate) {
    var Layout = ymaps.templateLayoutFactory.createClass('<div data-placemark-portal></div>', {
        build: function () {
            Layout.superclass.build.call(this);
            var el = this.getElement().childNodes[0];
            onCreate(el);
        }
    });
    return Layout;
};
var Placemark = function (props, ref) {
    var children = props.children, options = props.options, coords = props.coords, properties = props.properties, setRef = props.setRef, onClick = props.onClick, onDragstart = props.onDragstart, onDragend = props.onDragend, events = props.events;
    var _a = useState(null), element = _a[0], setElement = _a[1];
    var placemark = useState(function () {
        var finalOptions = __assign(__assign({}, options), (children && {
            iconLayout: createLayout(function (el) {
                if (!el) {
                    return;
                }
                setElement(el);
                if (setRef) {
                    setRef(el);
                }
            })
        }));
        return new ymaps.Placemark(coords, properties, finalOptions);
    })[0];
    // добавляем метку в коллекцию
    useCollection(placemark);
    // отдельно обновляем события,
    // чтобы не добавлять, и не удалять их на при каждом обновлении
    useEvent(placemark, 'click', onClick);
    useEvent(placemark, 'dragend', onDragend);
    useEvent(placemark, 'dragstart', onDragstart);
    useEvents(placemark, events);
    useGeoObjectCoords(placemark, coords);
    useGeoObjectOptions(placemark, options);
    useGeoObjectProperties(placemark, properties);
    useImperativeHandle(ref, function () { return placemark; });
    if (element) {
        return createPortal(children instanceof Function ? children() : children, element);
    }
    return null;
};
export default React.memo(forwardRef(Placemark));
